import React from "react";
import { Oval } from "react-loader-spinner";

const OvalLoader = () => {
  return (
    <>
      <Oval
        visible={true}
        height="80"
        width="80"
        color="#f46f30"
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </>
  );
};

export default OvalLoader;
